// native
import { NgModule } from '@angular/core';

// component
import { ContainerComponent } from './container.component';

// addon
import { FaIconLibrary, FaConfig, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// module
import { CoreModule } from './core/core.module';
import { ReferencesModule } from './references/references.module';
import { SharedModule } from './shared/shared.module';
import { OptionsModule } from './options/options.module';
import { BibliographyModule } from './bibliography/bibliography.module';
import { LoginModule } from './login/login.module';
import { SubscriptionModule } from './subscription/subscription.module';
import { ContextMenuModule } from '@readcube/ngx-contextmenu';

// icons
import { APP_ICONS } from './icons/app-icons';

@NgModule({
  declarations: [ContainerComponent],
  imports: [
    FontAwesomeModule,
    SharedModule,
    ReferencesModule,
    OptionsModule,
    LoginModule,
    SubscriptionModule,
    BibliographyModule,
    CoreModule.forRoot(),
    ContextMenuModule.forRoot({ useBootstrap4: true })
  ],
  exports: [ContainerComponent]
})
export class SmartciteSharedModule {
  constructor(
    faConfig: FaConfig,
    faIconLibrary: FaIconLibrary
  ) {
    faIconLibrary.addIcons(...APP_ICONS);
  }
}
